/* Package JSON Import will be here */
import React from 'react';
import { Segment, Form, Button, Image, Label, Input, Icon } from 'semantic-ui-react';
import './login.css';
import "../../assets/styles/styles.css";
import Loader from "../sharedComponent/loader/loader.js"
import packageJson from '../../../package.json';


const LoginComponent = props => {

    return (
        <Segment className="login-bg text-center heightFormSegment">
            <Form size='large' className="text-center formPadding formWidth">
                <Image className="d-inline-block mb-1" size='small' src={require('../../assets/images/logo_1.png')}></Image>
                <Label className="employeeNumber w-100">Employee Number :</Label>
                <Input className="loginInput"
                    icon={<Icon className='iconFullOpacity' name='close' circular link onClick={props.onClickClear} />}
                    // placeholder='Employee number'
                    value={props.login.employeePin}
                    onChange={(e) => props.handleInputChange(e)}
                    ref={props.login.inputRef}
                    onClick={props.onClickFocusInput}
                />
                <div className="maxHeightForm">
                    <div className="d-flex justify-content-between mt-2">
                        <Button className="compact big m-0" onClick={() => props.onClickNumbericInput(1)}>1</Button>
                        <Button className="compact big m-0" onClick={() => props.onClickNumbericInput(2)}>2</Button>
                        <Button className="compact big m-0" onClick={() => props.onClickNumbericInput(3)}>3</Button>
                    </div>
                    <div className="d-flex justify-content-between mt-2">
                        <Button className="compact big m-0" onClick={() => props.onClickNumbericInput(4)}>4</Button>
                        <Button className="compact big m-0" onClick={() => props.onClickNumbericInput(5)}>5</Button>
                        <Button className="compact big m-0" onClick={() => props.onClickNumbericInput(6)}>6</Button>
                    </div>
                    <div className="d-flex justify-content-between mt-2">
                        <Button className="compact big m-0" onClick={() => props.onClickNumbericInput(7)}>7</Button>
                        <Button className="compact big m-0" onClick={() => props.onClickNumbericInput(8)}>8</Button>
                        <Button className="compact big m-0" onClick={() => props.onClickNumbericInput(9)}>9</Button>
                    </div>
                    <div className="d-flex justify-content-center mt-2">
                        <Button className="compact big m-0" onClick={() => props.onClickNumbericInput(0)}>0</Button>
                    </div>
                    <div className="d-inline-block justify-content-center mt-1 w-100">
                        <Button className="secondary loginBtn w-100" size='medium' onClick={props.onClickLogin}>
                            <Icon name='lock' />  Login  </Button>
                        <Button className="secondary loginBtn w-100" size='medium' onClick={props.onClickDeviceNameUpdate}>
                            <Icon name='mobile alternate' /> Device Name Update </Button>
                    </div>
                    <Label className="versionText w-100 mt-1">V{packageJson.version}</Label>
                </div>


            </Form>
            {props.login.isShowLoader && <Loader />}
        </Segment>
    );
};

LoginComponent.displayName = "LoginComponent";

export default LoginComponent;